import debounce from "./debounce";

function triggerPopUp() {
  const isPresent = document.querySelector(".c-calc-window-wrapper");
  if (!isPresent) {
    return;
  }

  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires + ";path=/";
  }

  function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i=0; i<ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1);
        if (c.indexOf(name) == 0) return c.substring(name.length,c.length);
    }
    return "";
  }

  function amountscrolled() {
    function getDocHeight() {
      var D = document;
      return Math.max(
        D.body.scrollHeight,
        D.documentElement.scrollHeight,
        D.body.offsetHeight,
        D.documentElement.offsetHeight,
        D.body.clientHeight,
        D.documentElement.clientHeight
      );
    }

    const winheight =
      window.innerHeight ||
      (document.documentElement || document.body).clientHeight;
    const docheight = getDocHeight();
    const scrollTop =
      window.pageYOffset ||
      (document.documentElement || document.body.parentNode || document.body)
        .scrollTop;
    const trackLength = docheight - winheight;
    const pctScrolled = Math.floor((scrollTop / trackLength) * 100); // gets percentage scrolled

    const popup = document.querySelector(".c-calc-window-wrapper");
    const close = document.querySelectorAll(".c-calc-window-close");

    if (pctScrolled >= 50) {
      if (!popup.classList.contains("closed")) {
        popup.classList.remove("hidden");
      }

      document.onkeyup = function (event) {
        if (event.keyCode === 27) {
          popup.classList.add("hidden");
          popup.classList.add("closed");
          setCookie('calc_newsl_shown', 'yes', 365);
        }
      };
    }

    close.forEach((item) => {
      item.addEventListener("click", function () {
        popup.classList.add("hidden");
        popup.classList.add("closed");
        setCookie('calc_newsl_shown', 'yes', 365);
      });
    })

  }


    if(getCookie("calc_newsl_shown") === "yes") {
       // don't show the popup
    } else {
      window.addEventListener("scroll", debounce(amountscrolled));
    }
}

export default triggerPopUp;
